import { Chakra } from "@airhelp/react-ui-components";
import { useLinkRelValue } from "hooks";

interface LinkProps {
  text: string;
  href: string;
}

const { Link: ChakraLink } = Chakra;

const Link = ({ text, href }: LinkProps) => {
  const relValue = useLinkRelValue(href);

  return (
    <ChakraLink rel={relValue} href={href} isExternal fontSize="md" _visited={{}}>
      {text}
    </ChakraLink>
  );
};

export default Link;
